<template>
  <div class="more-wrap">
    <button class="gray-btn round-btn s-btn" type="button" @click="emit('get-more')">
      {{ t('more') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const emit = defineEmits<{
  'get-more': [];
}>();

const { t } = useI18n();
</script>

<style scoped lang="scss">
.more-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0;
  button {
    cursor: pointer;
    width: auto;
    padding: 0.5rem 1rem;
  }
}
</style>
